import {
  BooleanInput,
  Create,
  CreateContextProvider,
  Form,
  required,
  SaveButton,
  SelectInput,
  TextInput,
  Toolbar,
  TopToolbar,
  useCreateController,
  useNotify,
  useRedirect,
  useRefresh,
  useTranslate,
} from 'react-admin';
import {
  Box,
  Card,
  Divider,
  Stack,
  Typography,
  Button as MUIButton,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Resources } from '../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import { DashboardContent } from 'src/layouts/dashboard';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs/custom-breadcrumbs';
import ErrorPage403 from 'src/pages/error/403';
import CustomTagInput from 'src/pages/admin/components/CustomTagInput';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import UnlimiteAgentsForm from './UnlimiteAgentsForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const CreateUnlimitedAgents = ({ onClose }: { onClose: () => void }) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useCreateController({
    resource: Resources.unlimitedAgents,
    mutationOptions: {
      onSuccess: () => {
        notify('module.unlimitedAgents.createSuccess', { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        const msg = t(error?.body?.message) || t(error?.message) || 'module.unlimitedAgents.unknownError';
        notify(msg, { type: 'warning' });
      },
    },
  });

  return (
    <CreateContextProvider value={controller}>
      <Form disableInvalidFormNotification>
        <DialogTitle>{t('module.agents.createAgents')}</DialogTitle>
        <DialogContent>
          <UnlimiteAgentsForm isCreate />
        </DialogContent>
        <DialogActions>
          <MUIButton variant="outlined" onClick={onClose}>
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="unlimited-agents" action="create">
            <SaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </CreateContextProvider>
  );
};

export default CreateUnlimitedAgents;
